// extracted by mini-css-extract-plugin
export var notificationHost = "_fb-0";